declare var Drupal: any;

Drupal.behaviors.SystemMenuDropDown = {
  attach: () => {
    (jQuery('.sidenav') as any).sidenav();
    (jQuery('.dropdown-trigger') as any).dropdown({
      hover: true,
      autoTrigger: false,
      constrainWidth: false,
      coverTrigger: false,
    });
  },
};
